module.exports = __webpack_public_path__ + "static/media/Step4.ef8cd9a7.png";